import { StatusEnum } from '@/types/cart';
import Favorite from './favorite';
import { ProductCardProps } from '../types';
import useClickActionT2 from '@/tracks/useClickActionT2';
import { twMerge } from 'tailwind-merge';
import { getProductCardExtraAttrs } from '@/utils/productFormat';

const EnchancedFavorite = (
  props: Partial<
    ProductCardProps & {
      labelNode?: React.ReactNode | (() => React.ReactNode);
      headerContainerCls?: string;
      exactTargetPos?: number;
      className?: string;
    }
  >
) => {
  const {
    data,
    showFavorite = true,
    trackDataInDialog,
    positionInfoT2,
    supportPurchaseStatusNotify,
    exactTargetPos,
    className
  } = props;
  const { saveClick } = useClickActionT2();

  if (
    !showFavorite ||
    data?.category === 'bundle' ||
    data?.is_hotdish === 'Y' ||
    data?.sold_status === StatusEnum.sold_out
  ) {
    return null;
  }
  return (
    <div className={twMerge('absolute right-2 top-2.5 z-[1] w-auto pointer-events-auto', className)}>
      <Favorite
        id={data?.product_id || data?.id}
        supportPurchaseStatusNotify={supportPurchaseStatusNotify}
        onClick={targetCollect => {
          saveClick(
            Object.assign(trackDataInDialog || {}, {
              ...(positionInfoT2?.modSecPos || {}),
              co: {
                target_pos: exactTargetPos >= 0 ? exactTargetPos : positionInfoT2?.prodPos,
                target_nm: data?.id || data?.product_id,
                is_mkpl: data?.biz_type === 'seller'
              },
              ctx: {
                ...positionInfoT2?.context,
                extra_attrs: getProductCardExtraAttrs(data),
                volume_price_support: data?.volume_price_support ? true : false
              }
            }),
            targetCollect
          );
        }}
      />
    </div>
  );
};

export default EnchancedFavorite;
